import { MutableRefObject, useEffect, useRef, useState } from 'react';

interface IResult {
	ref: MutableRefObject<HTMLElement | null>;
	isComponentVisible: boolean;
	setIsComponentVisible: (isComponentVisible: boolean) => void;
}

export const useComponentVisible = (initialIsVisible: boolean): IResult => {
	const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
	const ref = useRef<HTMLElement | null>(null);

	const handleHideDropdown = (event: KeyboardEvent) => {
		if (event.key === 'Escape') {
			setIsComponentVisible(false);
		}
	};

	const handleClickOutside = (event: any) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setIsComponentVisible(false);
		} else if (!isComponentVisible) {
			setIsComponentVisible(true);
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleHideDropdown, true);
		document.addEventListener('mousedown', handleClickOutside, true); // The click event likely detects the release of the mouse button, which, in the case of a drag, may end up outside the element and then hide it - JP-5016
		return () => {
			document.removeEventListener('keydown', handleHideDropdown, true);
			document.removeEventListener('mousedown', handleClickOutside, true);
		};
	});

	return { ref, isComponentVisible, setIsComponentVisible };
};
